var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconIndicator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 8"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 73,
  r: 4,
  fill: "#0067C9",
  fillRule: "evenodd",
  transform: "translate(-9 -69)"
})));
export default SvgIconIndicator;